import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/contact-us.css";

export default function ContactUs(props) {
    const { t } = useTranslation();
    const localizer = t;

    return (
        <div>
            <h3>اطلاعات تماس</h3>
            <dl
                className="contact-address dl-horizontal"
                itemprop="address"
                itemscope=""
                itemtype="https://schema.org/PostalAddress"
            >
                <dt>
                    <span>آدرس: </span>
                </dt>

                <dd>
                    <span itemprop="streetAddress">
                        تهران، خیابان آیت الله کاشانی بعد از ستاری، روبه روی شهر کتاب,نبش
                        خیابان بنفشه، پلاک 464، ساختمان نور، طبقه 5، واحد32
                    </span>
                </dd>

                <dt>
                    <span>مدیریت: </span>
                </dt>
                <dd>
                    <span itemprop="telephone">02149208500 </span>
                </dd>
                <dt>
                    <span>کارشناس: </span>
                </dt>
                <dd>
                    <span itemprop="telephone">02149208400 </span>
                </dd>
                <dt>
                    <span>همراه پشتیبان: </span>
                </dt>
                <dd>
                    <span itemprop="telephone">09384083777 </span>
                </dd>
                <dt>
                    <span>پیام رسان داخلی: </span>
                </dt>
                <dd>
                    <span itemprop="telephone">09020045191 </span>
                </dd>

                <dt>
                    <span>پنل پیامکی ارسال پیام: </span>
                </dt>
                <dd>
                    <span itemprop="telephone">100045191000</span>
                </dd>
                <dt>
                    <span></span>
                </dt>
                <dd>
                    <span itemprop="telephone">9998883522 </span>
                </dd>
                <dt>
                    <span></span>
                </dt>
                <dd>
                    <span itemprop="telephone">20000045191000 </span>
                </dd>
            </dl>
        </div>
    );
}


